export default "__VITE_ASSET__BYpYidES__"